import React, { useMemo } from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import classNames from 'classnames';
import { H2 } from '../../../components';

import css from './SectionBenefits.module.css';

const SectionBenefits = props => {
  const { className } = props;

  const intl = useIntl();

  const classes = classNames(css.root, className);

  const listItems = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem1' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem2' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem3' }),
        subTitle: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem3subItem1' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem4' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem5' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem6' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem7' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem8' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem9' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem10' }),
        subTitle: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem10subItem1' }),
      },
      {
        title: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem11' }),
        subTitle: intl.formatMessage({ id: 'ArtistHelpPage.benefitsItem11subItem1' }),
      },
    ],
    [intl]
  );

  return (
    <div className={classes}>
      <H2 className={css.title}>
        <FormattedMessage
          id="ArtistHelpPage.benefitsTitle"
          values={{ span: msgFragment => <span className={css.primaryColor}>{msgFragment} </span> }}
        />
      </H2>

      <ul className={css.list}>
        {listItems.map((item, i) => {
          const { title, subTitle } = item;

          return (
            <li key={i}>
              <div className={css.itemTitle}>{title}</div>
              <div className={css.itemDesc}>{subTitle}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SectionBenefits;
